import { mask, object, string } from "superstruct";

export const config = mask(
  import.meta.env,
  object({
    VITE_ITC_API_ORIGIN: string(),
  })
);
